export function getLocalStorageSize() {
  let total = 0
  for (const key in localStorage) {
    if (localStorage.hasOwnProperty(key)) {
      total += localStorage[key].length + key.length
    }
  }
  return total
}

export function getLocalStorageSizeKB() {
  return getLocalStorageSize() / 1024
}

export function getLocalStorageSizeMB() {
  return getLocalStorageSizeKB() / 1024
}

export function hasEnoughLocalStorageSpace(dataSizeKB, maxStorageMB = 5) {
  const currentSizeMB = getLocalStorageSizeMB()
  const newDataSizeMB = dataSizeKB / 1024
  return (currentSizeMB + newDataSizeMB) < maxStorageMB
}

export function safeSetLocalStorageItem(key, value, onQuotaExceeded) {
  try {
    localStorage.setItem(key, value)
    return true
  } catch (error) {
    if (error.name === 'QuotaExceededError' || error.code === 22) {
      console.warn('localStorage quota exceeded', {
        currentSizeMB: getLocalStorageSizeMB(),
        attemptedItemSizeKB: (key.length + value.length) / 1024
      })
      if (onQuotaExceeded) {
        onQuotaExceeded(error)
      }
      return false
    }
    throw error
  }
}

export function cleanupOldImageData(keyPatterns = [], maxAge = 24 * 60 * 60 * 1000) {
  const now = Date.now()
  const keysToRemove = []

  for (const key in localStorage) {
    if (!localStorage.hasOwnProperty(key)) continue

    const matchesPattern = keyPatterns.some(pattern => {
      const regex = new RegExp(pattern)
      return regex.test(key)
    })

    if (!matchesPattern) continue

    const shouldRemove = checkIfOldImageData(localStorage[key], now, maxAge)
    if (shouldRemove) {
      keysToRemove.push(key)
    }
  }

  keysToRemove.forEach(key => {
    localStorage.removeItem(key)
  })

  return keysToRemove.length
}

function checkIfOldImageData(value, now, maxAge) {
  try {
    const parsedValue = JSON.parse(value)
    const hasImageData = JSON.stringify(parsedValue).includes('data:image/')

    if (!hasImageData) return false

    const timestamp = parsedValue.timestamp || parsedValue.created_at || 0
    return (now - timestamp) > maxAge
  } catch (e) {
    return typeof value === 'string' && value.startsWith('data:image/')
  }
}

export function getLocalStorageStats() {
  const sizeBytes = getLocalStorageSize()
  const sizeMB = getLocalStorageSizeMB()
  const itemCount = Object.keys(localStorage).length

  let imageDataSize = 0
  let imageDataCount = 0

  for (const key in localStorage) {
    if (localStorage.hasOwnProperty(key)) {
      const value = localStorage[key]
      if (value.includes('data:image/')) {
        imageDataSize += value.length
        imageDataCount++
      }
    }
  }

  return {
    totalSizeBytes: sizeBytes,
    totalSizeMB: sizeMB,
    totalItems: itemCount,
    imageDataSizeBytes: imageDataSize,
    imageDataSizeMB: imageDataSize / (1024 * 1024),
    imageDataCount: imageDataCount,
    usagePercentage: (sizeMB / 5) * 100
  }
}
